import {
    ACCOUNT_CLIENT_ID,
    ACCOUNT_DEMO_URL,
    ACCOUNT_DEV_URL,
    ACCOUNT_TEST_URL,
    APPLINKS_DEMO_URL,
    APPLINKS_DEV_URL,
    APPLINKS_TEST_URL,
} from '@eventr/common'
import { reactAppStage } from '../../utils/reactAppStage'

export const oidcConfig = () => {
    switch (reactAppStage()) {
        case 'dev':
            return {
                authority: ACCOUNT_DEV_URL,
                client_id: ACCOUNT_CLIENT_ID,
                redirect_uri:
                    import.meta.env.MODE === 'production'
                        ? `${APPLINKS_DEV_URL}/oauth/callback?stage=dev`
                        : 'http://localhost:3000/oauth/callback',
                client_secret: 'st2eLPCcwVCoKuQBWWRuM8mpcAVPFGe1',
            }
        case 'test':
            return {
                authority: ACCOUNT_TEST_URL,
                client_id: ACCOUNT_CLIENT_ID,
                redirect_uri:
                    import.meta.env.MODE === 'production'
                        ? `${APPLINKS_TEST_URL}/oauth/callback?stage=test`
                        : 'http://localhost:3000/oauth/callback?stage=test',
                client_secret: 'E0tlEi0NITMVN8mZvmsPy9reNtwNKPOz',
            }
        case 'demo':
            return {
                authority: ACCOUNT_DEMO_URL,
                client_id: ACCOUNT_CLIENT_ID,
                redirect_uri:
                    import.meta.env.MODE === 'production'
                        ? `${APPLINKS_DEMO_URL}/oauth/callback?stage=demo`
                        : 'http://localhost:3000/oauth/callback?stage=demo',
                client_secret: 'phZLEbaWiiaXXugAdoEqZb3T4UZ4xNyn',
            }
        case 'local':
            return {
                authority: 'http://localhost:4200/',
                client_id: ACCOUNT_CLIENT_ID,
                redirect_uri: 'http://localhost:3000/oauth/callback',
                client_secret: 'vIse7jPonTalW9UVktJmkBZkLML1wFOs',
            }
    }
}
